package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.theme.*

/**
 * Skip link style - hidden until focused for keyboard navigation accessibility.
 * Allows screen reader users to skip navigation and jump to main content.
 */
val SkipLinkStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .top((-999).px)
            .left((-999).px)
            .zIndex(9999)
            .padding(8.px)
            .backgroundColor(SiteTheme.green._900)
            .color(SiteTheme.white._900)
    }

    // Show when focused (keyboard navigation)
    cssRule(":focus") {
        Modifier
            .top(0.px)
            .left(0.px)
    }
}

/**
 * Accessibility skip link that allows keyboard users to bypass navigation.
 *
 * @param targetId ID of the main content element to skip to
 */
@Composable
fun SkipLink(targetId: String = "main-content") {
    Link(
        path = "#$targetId",
        text = "Przejdź do głównej treści",
        modifier = SkipLinkStyle.toModifier()
    )
}
